import { PageHeader } from "../components/FeatureCard";
import { getLang, t, tk } from "../lib/i18n";

/**
 * DRAFT legal pages. Payment gateways require these to exist; the wording must be reviewed by
 * the owner (and ideally a lawyer) before launch. Company details come from SSM.
 */
const COMPANY = "KRONI AI EMPIRE";

const PAGES = {
  terma: {
    title: tk("Terma & Syarat"),
    body: [
      `JomCerdik ialah produk ${COMPANY}. Dengan membeli, anda bersetuju dengan terma ini.`,
      "Lesen lifetime memberi satu akaun akses kepada semua modul JomCerdik yang tersedia sepanjang hayat produk. Lesen tidak boleh dipindah milik atau dikongsi.",
      "Harga: RM69 untuk 100 pembeli terus pertama, RM79 untuk pembeli terus ke-101 hingga 200, dan RM89 selepas itu. Pembelian melalui pautan affiliate adalah pada harga RM89.",
      "Setiap lesen termasuk 30 kredit AI; 1 kredit digunakan bagi setiap kertas soalan yang berjaya dijana. Penjanaan yang gagal tidak ditolak. Kredit tambahan boleh dibeli pada harga RM50 untuk 60 kertas. Kredit tidak boleh ditunaikan atau dipindah milik. Muat turun semula PDF sedia ada dan JomBelajar tidak menggunakan kredit.",
      "Kandungan dijana dan disemak untuk latihan. JomCerdik tidak diperakui oleh KPM dan bukan pengganti bahan rasmi sekolah.",
      "Satu sesi log masuk aktif dibenarkan pada satu masa. Log masuk baharu akan menamatkan sesi lama.",
      "Program affiliate terbuka kepada 200 pembeli awal yang mempunyai lesen aktif sahaja. Komisen satu peringkat bagi setiap jualan sah melalui pautan anda ialah RM89 tolak harga yang anda bayar (RM20 bagi pembeli RM69, RM10 bagi pembeli RM79), tertakluk kepada tempoh 14 hari dan semakan admin. Affiliate juga menerima RM10 setiap kali pengguna yang membeli melalui pautan mereka membuat tambahan kredit RM50, tertakluk kepada syarat yang sama.",
    ],
  },
  privasi: {
    title: tk("Dasar Privasi"),
    body: [
      `${COMPANY} mengumpul emel, maklumat pesanan dan rujukan bayaran untuk memproses pembelian dan memberi akses.`,
      "Kami menyimpan rekod kemajuan pembelajaran untuk memaparkan tahap penguasaan kepada pengguna.",
      "Kami tidak menjual data peribadi. Data dikongsi hanya dengan penyedia perkhidmatan yang diperlukan (hosting, emel, pembayaran).",
      "Anda boleh meminta salinan atau pemadaman data anda dengan menghubungi kami. Kami mematuhi Akta Perlindungan Data Peribadi 2010.",
    ],
  },
  refund: {
    title: tk("Polisi Pembatalan & Refund"),
    body: [
      "JomCerdik ialah produk digital yang diberikan serta-merta selepas bayaran disahkan. Semua jualan adalah muktamad dan tiada bayaran balik (refund) selepas bayaran disahkan, termasuk bagi tambahan kredit AI.",
      "Pengecualian: bayaran berganda bagi pesanan yang sama, atau bayaran yang tidak dapat dipadankan dengan sebarang pesanan, akan dikembalikan ke akaun asal dalam tempoh 7 hari bekerja selepas disemak.",
      "Jika berlaku bayaran balik di bawah pengecualian ini, lesen atau kredit dan komisen affiliate berkaitan akan dibatalkan.",
      "Hubungi kami dengan kod rujukan pesanan dan bukti bayaran untuk sebarang pertanyaan.",
    ],
  },
};

export function LegalPage({ page }: { page: keyof typeof PAGES }) {
  const p = PAGES[page];
  return (
    <article className="mx-auto max-w-2xl space-y-3">
      <PageHeader title={t(p.title)} subtitle={COMPANY} />
      {getLang() !== "ms" && <p className="text-xs text-muted">{t("Dokumen undang-undang ini dalam Bahasa Melayu. Versi Bahasa Melayu ialah rujukan rasmi.")}</p>}
      {p.body.map((para) => (
        <p key={para} lang="ms" className="text-sm leading-relaxed">{para}</p>
      ))}
    </article>
  );
}
